import React from "react";
import { View, Text, Button, Icon } from "ui";
import Modal from "@material-ui/core/Modal";
import { styled, theme } from "styles";
interface P {
  open?: boolean;
  onClose?: () => void;
}

const PresentationArray = [
  require("../assets/presentare/01.png"),
  require("../assets/presentare/02.jpg"),
  require("../assets/presentare/03.jpg"),
  require("../assets/presentare/04.jpg"),
  require("../assets/presentare/05.jpg"),
  require("../assets/presentare/06.jpg"),
  require("../assets/presentare/07.jpg"),
  require("../assets/presentare/08.jpg")
];

export default class PresentationModal extends React.Component<P> {
  public state = {
    index: 0
  };

  public handleNext = () => {
    this.setState({ index: this.state.index + 1 });
  }

  public handlePrevious = () => {
    this.setState({ index: this.state.index - 1 });
  }
  public handleKeyPress = e => {
    if (e.key === "ArrowLeft" && this.state.index !== 0) {
      this.setState({ index: this.state.index - 1 });
    }
    if (
      e.key === "ArrowRight" &&
      this.state.index !== PresentationArray.length - 1
    ) {
      this.setState({ index: this.state.index + 1 });
    }
  }

  public handleClose = () => {
    this.setState({ index: 0 });
    this.props.onClose();
  }

  public render = () => {
    let imgSrc = PresentationArray[this.state.index];
    const { index } = this.state;
    const { open } = this.props;
    return (
      <Modal
        open={open}
        onClose={this.handleClose}
        onKeyDown={this.handleKeyPress}
      >
        <React.Fragment>
          <Image src={imgSrc} />
          {index !== 0 && (
            <ArrowLeft onClick={this.handlePrevious}>
              <Icon name="arrow-left-circle" size={3} color={theme.colors.primary} />
            </ArrowLeft>
          )}
          {index !== PresentationArray.length - 1 && (
            <ArrowRight onClick={this.handleNext}>
              <Icon name="arrow-right-circle" size={3} color={theme.colors.primary} />
            </ArrowRight>
          )}
          <CloseButton onClick={this.handleClose}>
            <Icon name="close-circle" size={3} color={theme.colors.primary} />
          </CloseButton>
        </React.Fragment>
      </Modal>
    );
  }
}

const Image = styled.img`
  border: 2px solid black;
  border-radius: 10px;
  user-select: none;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  max-width: 100%;
  max-height: 99%;
  margin: auto;
  overflow: auto;
  outline: 0;
`;

const ArrowRight = styled(View)`
  position: fixed;
  top: 20rem;
  right: 12rem;
  color: #f16541;
  cursor: pointer;
`;
const ArrowLeft = styled(View)`
  position: fixed;
  top: 20rem;
  left: 12rem;
  color: #f16541;
  cursor: pointer;
`;

const CloseButton = styled(View)`
  position: fixed;
  color: #f16541;
  top: 1rem;
  right: 12rem;
  cursor: pointer;
`;



// WEBPACK FOOTER //
// ./src/pages/PresentationModal.tsx